/**
 * The shared body of the Damage and Item status sections: a hint, one
 * Yes/No row per question, and "Mark unanswered as No" while any are blank.
 * Every row must be answered to complete the inspection.
 */

import React from 'react';
import type { CheckInInspectionCheck } from '@techgitter/contracts';

import type { InspectionCheckRow } from '../../../../utils/inspectionSchema';
import { YesNoCheckRow } from '../YesNoCheckRow';

export interface ChecklistSectionProps {
  rows: InspectionCheckRow[];
  checks: Record<string, CheckInInspectionCheck>;
  readOnly?: boolean;
  onChangeCheck: (key: string, check: CheckInInspectionCheck) => void;
  onMarkAllNo: () => void;
}

/** Shared body for Damage and Item status: a hint, the rows, the bulk action. */
export const ChecklistSection: React.FC<ChecklistSectionProps & { hint: string }> = ({
  hint,
  rows,
  checks,
  readOnly = false,
  onChangeCheck,
  onMarkAllNo,
}) => {
  const anyUnanswered = rows.some(row => !checks[row.key]?.status);
  return (
    <div className="ci-section">
      {!readOnly && <div className="ci-caption">{hint}</div>}
      <div>
        {rows.map(row => (
          <YesNoCheckRow
            key={row.key}
            label={row.label}
            value={checks[row.key] ?? { status: null, notes: null }}
            readOnly={readOnly}
            onChange={check => onChangeCheck(row.key, check)}
          />
        ))}
      </div>
      {!readOnly && anyUnanswered && (
        <button
          type="button"
          className="ci-btn ci-btn--ghost ci-btn--sm"
          onClick={onMarkAllNo}
          style={{ alignSelf: 'flex-start' }}
        >
          Mark unanswered as &quot;No&quot;
        </button>
      )}
    </div>
  );
};
